import OrderType from '../../utils/OrderType';
import { getTrackingHomeOrderType } from '../../selectors/trackingSelectors';

import {
  TRACK_VIEWED_MOBILE_FILTERS,
  TRACK_TAPPED_FILTER,
  TRACK_TAPPED_FILTER_OPTION,
  TRACK_TAPPED_FILTER_ICON,
  TRACK_TOGGLE_FILTER_SECTION,
  TRACK_TAPPED_LOGISTICS_CONTROL,
  TRACK_VIEWED_LOGISTICS_CONTROL,
  TRACK_VIEWED_DELIVERY_TIME_PICKER,
  TRACK_CHANGED_DELIVERY_TIME,
  TRACK_TOGGLED_DELIVERY_TYPE,
} from './types';

export const trackTappedFilter = ({ id }) => ({
  type: TRACK_TAPPED_FILTER,
  payload: {
    name: 'Tapped Filter',
    properties: {
      filter_id: id,
    },
  },
});

export const trackTappedFilterOption = ({ filterOption, filter, selected }) => (
  dispatch,
  getState,
) => {
  const state = getState();

  return dispatch({
    type: TRACK_TAPPED_FILTER_OPTION,
    payload: {
      name: 'Tapped Filter Option',
      properties: {
        ...getTrackingHomeOrderType(state),
        filter_id: filter.id,
        filter_option_id: filterOption.id,
        filter_option_target_params: filterOption.target_params.params,
        selected,
      },
    },
  });
};

export const trackTappedFilterIcon = () => (dispatch, getState) => {
  const state = getState();

  return dispatch({
    type: TRACK_TAPPED_FILTER_ICON,
    payload: {
      name: 'Tapped Filter Icon',
      properties: {
        ...getTrackingHomeOrderType(state),
      },
    },
  });
};

export const trackToggleFilterSection = ({ filterId, isOpen }) => ({
  type: TRACK_TOGGLE_FILTER_SECTION,
  payload: {
    name: 'Toggle Filter Section',
    properties: {
      filter_id: filterId,
      expanded: isOpen,
    },
  },
});

export const trackViewedMobileFiltersHomeFeed = (filterId) => (dispatch, getState) => {
  const state = getState();

  let filters = [...state.home.feed.sort, ...state.home.feed.filters];
  let eventName = 'Viewed Filters';

  if (filterId) {
    filters = filters.filter((filter) => filter.id === filterId);
    eventName = 'Viewed Filter Section';
  }

  const mappedFilters = filters.map((filter) => ({
    filter_id: filter.id,
    filter_options_count: filter.options.length,
    filter_options: filter.options.map((option) => ({
      filter_option_id: option.id,
    })),
  }));

  return dispatch({
    type: TRACK_VIEWED_MOBILE_FILTERS,
    payload: {
      name: eventName,
      properties: {
        ...getTrackingHomeOrderType(state),
        filters: mappedFilters,
      },
    },
  });
};

export const trackTappedLogisticsControl = (sourceView) => (dispatch, getState) => {
  const state = getState();

  return dispatch({
    type: TRACK_TAPPED_LOGISTICS_CONTROL,
    payload: {
      name: 'Tapped Time and Location Picker',
      properties: {
        ...getTrackingHomeOrderType(state),
        'Source view': sourceView,
      },
    },
  });
};

export const trackViewedLogisticsControl = (sourceView) => (dispatch, getState) => {
  const state = getState();

  return dispatch({
    type: TRACK_VIEWED_LOGISTICS_CONTROL,
    payload: {
      name: 'Viewed Time and Location Sheet',
      properties: {
        ...getTrackingHomeOrderType(state),
        'Source view': sourceView,
      },
    },
  });
};

export const trackViewedDeliveryTimePicker = (sourceView) => (dispatch, getState) => {
  const state = getState();

  return dispatch({
    type: TRACK_VIEWED_DELIVERY_TIME_PICKER,
    payload: {
      name: 'Viewed Delivery Time Picker',
      properties: {
        ...getTrackingHomeOrderType(state),
        'Source view': sourceView,
      },
    },
  });
};

export const trackChangedDeliveryTime = (sourceView) => (dispatch, getState) => {
  const state = getState();

  return dispatch({
    type: TRACK_CHANGED_DELIVERY_TIME,
    payload: {
      name: 'Changed Delivery Time',
      properties: {
        ...getTrackingHomeOrderType(state),
        'Source view': sourceView,
      },
    },
  });
};

export const trackToggledDeliveryType = (nextFulfillmentMethod, sourceView) => ({
  type: TRACK_TOGGLED_DELIVERY_TYPE,
  payload: {
    name: 'Toggled delivery type',
    properties: {
      'New delivery type': OrderType.fromFulfillmentMethod(nextFulfillmentMethod),
      'Source view': sourceView,
    },
  },
});
